/* eslint-env browser */

import PropTypes from 'prop-types'
import * as React from 'react'
import Smooch from 'smooch'
import isEmail from 'validator/lib/isEmail'

const axios = require('axios')

const Counterpart = require('@gandi/counterpart').Instance
const translate = new Counterpart()
translate.registerTranslations('en', require('./i18n/en'))
translate.registerTranslations('fr', require('./i18n/fr'))

class NewSubmissionForm extends React.PureComponent {
  constructor() {
    super()
    this.updateSmoochData = this.updateSmoochData.bind(this)
    this.getFormControl = this.getFormControl.bind(this)
    this.isValid = this.isValid.bind(this)
    this.everythingIsValid = this.everythingIsValid.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.updateStateValueOnInputChange = this.updateStateValueOnInputChange.bind(this)
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      position: '',
      businessName: '',
      loading: false,
      showMissingDataAlert: false,
      errorFromServer: undefined,
    }
  }

  componentWillMount() {
    if (this.props.localeShortIdentifier !== translate.getLocale()) {
      translate.setLocale(this.props.localeShortIdentifier)
    }
  }

  onSubmit(e) {
    if (e) {
      e.preventDefault()
    }
    if (!this.everythingIsValid()) {
      this.setState({ showMissingDataAlert: true }, this.updateSmoochData)
      return
    }
    const thiz = this
    this.setState({ showMissingDataAlert: false, loading: true }, function() {
      thiz.updateSmoochData()
      axios
        .post('/api/businesses', {
          contact: {
            firstName: thiz.state.firstName,
            lastName: thiz.state.lastName,
            email: thiz.state.email,
            position: thiz.state.position,
          },
          businessName: thiz.state.businessName,
        })
        .then(function(res) {
          setTimeout(function() {
            window.location.href = `${window.location.origin}/business/continue/${res.data.id}`
          })
        })
        .catch(function(err) {
          thiz.handleServerError(err)
          thiz.setState({ loading: false })
        })
    })
  }

  getFormControl(opts) {
    const cross = <i className="fa fa-times" style={{ float: 'left', paddingTop: 3, color: 'grey' }} />
    const check = <i className="fa fa-check" style={{ float: 'left', paddingTop: 3, color: 'green' }} />

    return (
      <div className="form-group">
        <div className="column col-sm-3 col-md-3 col-lg-4">
          <label className="form-label" htmlFor="input-example-1">
            {translate.translate(opts.labelKey)}
          </label>
        </div>
        <div
          className={`column col-xs-12 col-sm-8 col-md-8 col-lg-7 ${opts.tooltipKey ? 'tooltip tooltip-top' : ''}`}
          data-tooltip={opts.tooltipKey ? translate.translate(opts.tooltipKey) : undefined}
        >
          <input
            type="text"
            value={this.state[opts.stateKey]}
            onChange={this.updateStateValueOnInputChange(opts)}
            className="form-input"
            id={opts.controlId}
            placeholder={translate.translate(opts.labelKey)}
          />
          {opts.below ? opts.below(this) : undefined}
        </div>
        {this.isValid(opts.validKey) ? check : cross}
      </div>
    )
  }

  updateSmoochData() {
    try {
      Smooch.updateUser({
        givenName: `${this.state.firstName}.trim() ${this.state.lastName}.trim()`,
        email: this.state.email,
        properties: this.state,
      })
    } catch (e) {}
  }

  updateStateValueOnInputChange(opts) {
    const thiz = this
    return function(e) {
      const newState = {}
      newState[opts.stateKey] = e.target.value
      thiz.setState(newState)
    }
  }

  handleServerError(err) {
    this.setState({ errorFromServer: JSON.stringify(err.data) }, this.updateSmoochData)
  }

  everythingIsValid() {
    const isValid = this.isValid
    return (
      isValid('firstName') && isValid('lastName') && isValid('email') && isValid('position') && isValid('businessName')
    )
  }

  isValid(elt) {
    const s = this.state
    switch (elt) {
      case 'firstName':
        return s.firstName && s.firstName.length > 0
      case 'lastName':
        return s.lastName && s.lastName.length > 0
      case 'email':
        return s.email && s.email.length > 0 && isEmail(s.email)
      case 'position':
        return s.position && s.position.length > 0
      case 'businessName':
        return s.businessName && s.businessName.length > 0
      default:
        return false
    }
  }

  render() {
    let content
    if (this.state.loading) {
      content = (
        <div>
          <div className="loading loading-lg" />
        </div>
      )
    } else {
      content = (
        <div style={{ padding: 10 }}>
          <div dangerouslySetInnerHTML={{ __html: translate.translate('form.contact.intro') }} />
          <form className="form form-horizontal" onSubmit={this.onSubmit}>
            {this.getFormControl({
              controlId: 'contactFirstName',
              labelKey: 'form.contact.firstName.label',
              stateKey: 'firstName',
              validKey: 'firstName',
            })}
            {this.getFormControl({
              controlId: 'contactLastName',
              labelKey: 'form.contact.lastName.label',
              stateKey: 'lastName',
              validKey: 'lastName',
            })}
            {this.getFormControl({
              controlId: 'contactEmail',
              labelKey: 'form.contact.email.label',
              tooltipKey: 'form.contact.email.tooltip',
              stateKey: 'email',
              validKey: 'email',
              below(thiz) {
                if (thiz.state.email && thiz.state.email.length > 0 && !isEmail(thiz.state.email)) {
                  return <p className="form-input-hint">{translate.translate('form.contact.email.help')}</p>
                }
                return undefined
              },
            })}
            {this.getFormControl({
              controlId: 'positionName',
              labelKey: 'form.contact.position.label',
              tooltipKey: 'form.contact.position.tooltip',
              stateKey: 'position',
              validKey: 'position',
            })}
            <hr />
            {this.getFormControl({
              controlId: 'activityName',
              labelKey: 'form.activity.name.label',
              tooltipKey: 'form.activity.name.tooltip',
              stateKey: 'businessName',
              validKey: 'businessName',
            })}
            <input type="submit" style={{ display: 'none' }} />
          </form>
          {this.state.showMissingDataAlert && !this.everythingIsValid() && (
            <div className="toast toast-warning">
              <button
                className="btn btn-clear float-right"
                onClick={() => this.setState({ showMissingDataAlert: false })}
              />
              {translate.translate('form.missingData')}
            </div>
          )}
          {this.state.errorFromServer && (
            <div className="toast toast-error">
              <button
                className="btn btn-clear float-right"
                onClick={() => this.setState({ errorFromServer: undefined })}
              />
              {translate.translate('form.serverError')}
              <br />
              {this.state.errorFromServer}
            </div>
          )}
        </div>
      )
    }

    return (
      <div>
        <div className="modal-header">
          <div className="modal-title h5">{translate.translate('form.titles.basic')}</div>
        </div>
        <div className="modal-body">
          <div className="content">{content}</div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-primary" disabled={this.state.loading} onClick={this.onSubmit}>
            {translate.translate('form.actions.next')}
          </button>
        </div>
      </div>
    )
  }
}

NewSubmissionForm.propTypes = {
  localeShortIdentifier: PropTypes.string.isRequired,
}

module.exports = NewSubmissionForm
